export const SUPPLIER_STATUS = {
  PROFILE_INCOMPLETE: 1,
  INCOMPLETE: 2,
  ACTIVE: 3,
  ARCHIVED: 4,
};

export const cardSurface = {
  background: "var(--surface)",
  borderRadius: 12,
  border: "1px solid #e2e6ea",
  overflow: "hidden",
  boxShadow: "0 1px 3px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.05)",
};

export const tableCardSurface = {
  ...cardSurface,
  overflow: "visible",
};

export const filterBarStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: 10,
  alignItems: "center",
  padding: "12px 16px",
  marginBottom: 12,
  background: "var(--surface)",
  borderRadius: 12,
  border: "1px solid #e2e6ea",
  boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
};

export const thStyle = {
  fontSize: 10,
  fontWeight: 700,
  color: "var(--ink-4)",
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  fontFamily: "var(--font-mono)",
  borderColor: "var(--rule)",
  background: "#f4f6f9",
};

export const detailSectionStyle = {
  border: "1px solid var(--rule)",
  borderRadius: 10,
  padding: "14px 16px",
  background: "#fafbfc",
};

export const detailSectionTitle = {
  fontSize: 10,
  fontWeight: 700,
  color: "var(--ink-4)",
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  fontFamily: "var(--font-mono)",
  marginBottom: 10,
};

export const detailLabelStyle = {
  fontSize: 11,
  color: "var(--ink-4)",
  fontFamily: "var(--font-mono)",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  marginBottom: 2,
};

export const detailValueStyle = {
  fontSize: 13,
  color: "var(--ink-2)",
  fontWeight: 600,
  wordBreak: "break-word",
};
